export function LogRoutes(routes) {
    console.log(routes.map(route => route.pathMatcher.path));
}
//# sourceMappingURL=log-routes.js.map